import { Check, Clipboard } from "lucide-react"
import type { ReactNode } from "react"
import { Button } from "@/components/ui/button"

const TOKEN_RE = /(&lt;\/?[a-z-]+&gt;|&lt;[a-z-]+|[a-z-]+(?==)|"[^"]*")/gi

function highlight(line: string): ReactNode[] {
  const escaped = line.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  const parts = escaped.split(TOKEN_RE)
  return parts.map((part, index) => {
    if (/^&lt;\/?[a-z-]+&gt;$|^&lt;[a-z-]+$/i.test(part)) return <span key={index} className="text-info" dangerouslySetInnerHTML={{ __html: part }} />
    if (/^"[^"]*"$/.test(part)) return <span key={index} className="text-success">{part}</span>
    if (/^[a-z-]+$/i.test(part) && part.length && line.includes(`${part}=`)) return <span key={index} className="text-warning">{part}</span>
    return <span key={index} className="text-foreground" dangerouslySetInnerHTML={{ __html: part }} />
  })
}

export function CodeBlock({ code, language = "HTML", onCopy, copied, showCopy = true }: {
  code: string
  language?: string
  onCopy: () => void
  copied: boolean
  showCopy?: boolean
}) {
  return (
    <div className="bg-background overflow-hidden rounded-xl border border-border">
      <div className="flex h-11 items-center gap-2 border-b border-border px-4">
        <span className="size-2 rounded-full bg-destructive/70" />
        <span className="size-2 rounded-full bg-warning/70" />
        <span className="size-2 rounded-full bg-success/70" />
        <span className="text-muted-foreground ml-2 font-mono text-[11px]">{language}</span>
        {showCopy && <Button type="button" size="sm" variant="outline" className="ml-auto h-8 min-w-[104px] rounded-lg border-border bg-card text-xs font-semibold" onClick={onCopy}>
          {copied ? <Check className="text-success mr-1.5 size-3.5" /> : <Clipboard className="mr-1.5 size-3.5" />}
          {copied ? "Copiado" : "Copiar código"}
        </Button>}
      </div>
      <pre className="overflow-x-auto p-5 text-[12px] leading-6"><code className="font-mono whitespace-pre">{code.split("\n").map((line, index) => <div key={index}>{highlight(line)}</div>)}</code></pre>
    </div>
  )
}
